import { useQuery } from "@tanstack/react-query";

import { supabase } from "~/integrations/supabase/client";

export const useAvailableSnapshotDates = () => {
  const query = useQuery({
    queryKey: ["available-snapshot-dates"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("daily_debt_summary")
        .select("snapshot_date")
        .order("snapshot_date", { ascending: false });

      if (error) throw error;

      return data?.map((d) => d.snapshot_date) || [];
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
  });

  return {
    dates: query.data || [],
    latestDate: query.data?.[0] || null,
    earliestDate: query.data?.[query.data.length - 1] || null,
    loading: query.isLoading,
    error: query.error?.message || null,
  };
};
